import { categories } from "../data/data";
const Categories = () => {
  return (
    <div className="max-w-[1910px] m-auto px-4 py-12">
      <h1 className="text-orange-600 font-bold text-4xl text-center capitalize">top rated menu items</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 py-6">
        {categories.map((item, index) => (
          <div key={index} className="bg-gray-100 rounded-lg p-4 flex justify-between items-center">
            <h2 className="font-bold sm:text-xl">{item.name}</h2>
            <img className="w-20" src={item.image} alt={item.name} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Categories;
